<template>
  <div>
    <ContactFloatingBtn />
    <div class="page-container">
      <div class="page-title">
        <h1>{{$t('contactPage.text1')}}</h1>
        <p>{{$t('contactPage.text2')}}</p>
      </div>
      <div class="map-container">
        <img src="@/assets/images/map-sample.png" alt="" />
      </div>
      <div class="company-info">
        <div class="address">{{$t('contactPage.text3')}}</div>
        <ul>
          <li>
            <span>T</span>
            <a href="tel:02 2068 9464">02 2068 9464</a>
          </li>
          <li>
            <span>F</span>
            02 2068 9465
          </li>
          <li>
            <span>E</span>
            <a class="email" href="mailto:jangjh@delkoit.co.kr">jangjh@delkoit.co.kr</a>
          </li>
          <li v-html="$t('contactPage.text4')">
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ContactFloatingBtn from '../components/ContactFloatingBtn.vue';
export default {
	name: 'ContactPage',
  components: {ContactFloatingBtn },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
